import { getCountryName } from 'v2/utils/country';

interface GetFallbackDisplayNameForEqlFieldValueIfRequiredOptions {
  field: string;
  value: string;
}

export const getFallbackDisplayNameForEqlFieldValueIfRequired = ({
  field,
  value,
}: GetFallbackDisplayNameForEqlFieldValueIfRequiredOptions) => {
  if (field === 'metadata.common.country') {
    return getCountryName(value);
  }
  return value;
};
